import * as React from "react";

import { cn } from "../../lib/utils";

const Loader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("flex items-center gap-1.5 text-gray-500", className)}
      aria-label="Ładowanie"
      {...props}
    >
      {[0, 1, 2].map((index) => (
        <span
          key={index}
          className="h-2 w-2 rounded-full bg-current"
          style={{
            animation: "ai-elements-loader-dot 900ms ease-in-out infinite",
            animationDelay: `${index * 140}ms`,
          }}
        />
      ))}
      <style>
        {`
          @keyframes ai-elements-loader-dot {
            0%, 80%, 100% { opacity: 0.35; transform: translateY(0); }
            40% { opacity: 1; transform: translateY(-3px); }
          }
        `}
      </style>
    </div>
  ),
);
Loader.displayName = "Loader";

export { Loader };
